export const userData = [
  {
    name: "Jan",
    "Active User": 4000,
  },
  {
    name: "Feb",
    "Active User": 3000,
  },
  {
    name: "Mar",
    "Active User": 5000,
  },
  {
    name: "Apr",
    "Active User": 2000,
  },
  {
    name: "May",
    "Active User": 1000,
  },
  {
    name: "Jun",
    "Active User": 5000,
  },
  {
    name: "Jul",
    "Active User": 3000,
  },
  {
    name: "Aug",
    "Active User": 2000,
  },
  {
    name: "Sep",
    "Active User": 5000,
  },
  {
    name: "Oct",
    "Active User": 4000,
  },
  {
    name: "Nov",
    "Active User": 3000,
  },
  {
    name: "Dec",
    "Active User": 1000,
  },
];
export const ProductData = [
  {
    name: "Jan",
    Sales: 4000,
  },
  {
    name: "Feb",
    Sales: 3000,
  },
  {
    name: "Mar",
    Sales: 5000,
  },
  {
    name: "Apr",
    Sales: 2000,
  },
];

export const userRows = [
  {
    id: 1,
    username: "Jack Dunn",
    avatar: "https://images.pexels.com/photos/5625995/pexels-photo-5625995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    email: "jackdunn@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 2,
    username: "Jack Dunn",
    avatar: "https://images.pexels.com/photos/5625995/pexels-photo-5625995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    email: "jackdunn@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 3,
    username: "Jack Dunn",
    avatar: "https://images.pexels.com/photos/5625995/pexels-photo-5625995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    email: "jackdunn@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 4,
    username: "Jack Dunn",
    avatar: "https://images.pexels.com/photos/5625995/pexels-photo-5625995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    email: "jackdunn@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 5,
    username: "Jack Dunn",
    avatar: "https://images.pexels.com/photos/5625995/pexels-photo-5625995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    email: "jackdunn@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 6,
    username: "Jack Dunn",
    avatar: "https://images.pexels.com/photos/5625995/pexels-photo-5625995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    email: "jackdunn@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 7,
    username: "Jack Dunn",
    avatar: "https://images.pexels.com/photos/5625995/pexels-photo-5625995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    email: "jackdunn@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 8,
    username: "Jack Dunn",
    avatar: "https://images.pexels.com/photos/5625995/pexels-photo-5625995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    email: "jackdunn@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 9,
    username: "Jack Dunn",
    avatar: "https://images.pexels.com/photos/5625995/pexels-photo-5625995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    email: "jackdunn@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 10,
    username: "Jack Dunn",
    avatar: "https://images.pexels.com/photos/5625995/pexels-photo-5625995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    email: "jackdunn@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
];
export const productRows = [
  {
    id: 1,
    name: "Apple Watch",
    img: "https://images.pexels.com/photos/437037/pexels-photo-437037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    stck: 12,
    status: "active",
    price: "$120.00",
  },
  {
    id: 2,
    name: "Apple Watch",
    img: "https://images.pexels.com/photos/437037/pexels-photo-437037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    stck: 12,
    status: "active",
    price: "$120.00",
  },
  {
    id: 3,
    name: "Apple Watch",
    img: "https://images.pexels.com/photos/437037/pexels-photo-437037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    stck: 12,
    status: "active",
    price: "$120.00",
  },
  {
    id: 4,
    name: "Apple Watch",
    img: "https://images.pexels.com/photos/437037/pexels-photo-437037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    stck: 12,
    status: "active",
    price: "$120.00",
  },
  {
    id: 5,
    name: "Apple Watch",
    img: "https://images.pexels.com/photos/437037/pexels-photo-437037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    stck: 12,
    status: "active",
    price: "$120.00",
  },
  {
    id: 6,
    name: "Apple Watch",
    img: "https://images.pexels.com/photos/437037/pexels-photo-437037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    stck: 12,
    status: "active",
    price: "$120.00",
  },
  {
    id: 7,
    name: "Apple Watch",
    img: "https://images.pexels.com/photos/437037/pexels-photo-437037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    stck: 12,
    status: "active",
    price: "$120.00",
  },
  {
    id: 8,
    name: "Apple Watch",
    img: "https://images.pexels.com/photos/437037/pexels-photo-437037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    stck: 12,
    status: "active",
    price: "$120.00",
  },
  {
    id: 9,
    name: "Apple Watch",
    img: "https://images.pexels.com/photos/437037/pexels-photo-437037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    stck: 12,
    status: "active",
    price: "$120.00",
  },
  {
    id: 10,
    name: "Apple Watch",
    img: "https://images.pexels.com/photos/437037/pexels-photo-437037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    stck: 12,
    status: "active",
    price: "$120.00",
  },
];
